const isInactive = status => {
  return status === 'inactive'
}

const isFinished = status => {
  return status === 'finished'
}

const show = status => {
  return isInactive(status) || isFinished(status)
}

export default {
  isInactive,
  isFinished,
  show,
}
